import React from 'react';

import { Button, ButtonTypeMap, styled } from '@mui/material';
import { OverrideProps } from '@mui/material/OverridableComponent';

type Props<T extends React.ElementType> = {
  subline: string;
  headline: string;
  link: {
    component: T;
    label: string;
    props: OverrideProps<ButtonTypeMap, T>;
  };
};

export const ContactTileTeaser = <T extends React.ElementType>({
  subline,
  headline,
  link,
}: Props<T>) => {
  return (
    <Container>
      <Subline>{subline}</Subline>
      <Headline>{headline}</Headline>
      <Button
        sx={{ width: { xs: '100%', md: 'auto' } }}
        {...link.props}
        component={link.component}
        variant="contained"
        color="primary"
      >
        {link.label}
      </Button>
    </Container>
  );
};

export default ContactTileTeaser;

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 'var(--spacer-m) 20px',
}));

const Subline = styled('p')(({ theme }) => ({
  ...theme.typography.footnote,
  margin: '0 0 var(--spacer-m) 0',
  fontWeight: theme.typography.fontWeightMedium,
}));

const Headline = styled('h2')(({ theme }) => ({
  ...theme.typography.h2,
  margin: '0 0 var(--spacer-xl) 0',
}));
